import { createContext, useContext } from "react";

export type ChromeMode = "default" | "dark-overlay";

export const ChromeModeContext = createContext<
  (mode: ChromeMode | null) => void
>(() => {});

export const useSetChromeMode = () => useContext(ChromeModeContext);
